module.exports = "https://cdn.redage.net/src/views/games/other/images/action/cure.png";